<template>
  <v-container fluid>
      <section class="content-header">
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Actualización Masiva de POD</v-toolbar-title>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical />
                  <v-text-field full-width v-model="desde" type="date" clearable label="Desde"></v-text-field><v-divider class="mx-4" vertical />
                  <v-text-field full-width v-model="hasta" type="date" clearable label="Hasta"></v-text-field><v-divider class="mx-4" vertical />
                 <v-btn dark dense @click="fillGuiasPndPod()" outlined> Buscar <v-icon>mdi-file-find</v-icon></v-btn>
                 <v-divider class="mx-4" vertical></v-divider>
                 <v-btn dark dense @click="actualizarPOD()" outlined> Actualizar POD <v-icon>mdi-find-replace</v-icon></v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <!--v-toolbar-items>
                  <v-divider vertical></v-divider>
                    <v-tooltip bottom color="#96298A">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-large v-bind="attrs" v-on="on" @click="exportToExcel()">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
              </v-toolbar-items-->
          </v-toolbar>
      </section>
      <v-row>
          <v-col cols="12" sm="12" md="12">
              <v-card outlined>
                  <v-card-title>Guias Pendientes de POD : <span v-if="guias.length > 0">Guias Pendientes: {{guias.length}} - Guias Actualizadas {{guiasActualizadas}}</span></v-card-title>
                  <v-card-text>
                      <v-data-table
                        :headers="headers"
                        :items="guias"
                        :items-per-page="-1"
                      >
                        <template v-slot:item.created_at="{ item }">
                            {{formatDate(item.created_at)}}
                        </template>
                      </v-data-table>
                  </v-card-text>
              </v-card>
          </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <waiting :totalGuias="guias.length" :currentGuia="currentGuia" :guiaCreada="guiaCreada" />
      </v-overlay>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import Waiting from '../components/WaitingActualizandoPOD.vue'
import utils from '../utils/utils'
export default {
    created: function(){},
    components:{
        Waiting
    },
    data() {
        return{
            overlay: false,
            guias: [],
            desde: null,
            hasta: null,
            currentGuia: 1,
            guiasActualizadas: 0,
            guiaCreada: null,
            headers:[
                { text: "Fecha Guía", value: "created_at", sortable: false },
                { text: "Guia Interna", value: "guia_interna", sortable: false },
                { text: "Operador", value: "proveedor", sortable: false },
                { text: "Guia Operador", value: "guia_proveedor", sortable: false },
                { text: "POD Persona que Recibe", value: "podnombre", sortable: false },
                { text: "POD Fecha", value: "podfecha", sortable: false },
                { text: "POD Hora", value: "podhora", sortable: false },
            ],
        }
    },
    methods:{
        fillGuiasPndPod: function(){
            apicon.saveDataApi(apicon.getApiBaseUrl() + 'getguiaspndpod',{
            desde: this.desde,
            hasta: this.hasta}).then((result) => {
                this.guias = result;
            });
        },
        actualizarPOD:async function(){
            this.overlay = true;
            for (var i = 0; i < this.guias.length; i++) {
                this.guiaCreada = this.guias[i].guia_interna;
                var urlrast = "rastrearguia/" + this.guias[i].guia_interna;
                await apicon.getDataApi(apicon.getApiBaseUrl() + urlrast).then(async(result) => {
                    if (result.proveedor == "UPS") {
                        //Verificar si tiene POD
                        let datosTr = result.datos[0].package[0];
                        if(datosTr.currentStatus.code == '011'){
                          await apicon.updateDataApi(apicon.getApiBaseUrl() + 'guias/' + this.guias[i].id,{
                                      podnombre: datosTr.deliveryInformation.receivedBy,
                                      podfecha: datosTr.deliveryDate[0].date,
                                      podhora: datosTr.deliveryTime.endTime
                                  })
                          this.guias[i].podnombre = datosTr.deliveryInformation.receivedBy;
                          this.guias[i].podfecha = datosTr.deliveryDate[0].date.substr(0,4) + '-' + datosTr.deliveryDate[0].date.substr(4,2) + '-' + datosTr.deliveryDate[0].date.substr(6,2);
                          this.guias[i].podhora = datosTr.deliveryTime.endTime.substr(0,2) + ':' + datosTr.deliveryTime.endTime.substr(2,2) + ':' + datosTr.deliveryTime.endTime.substr(4,2);
                          this.guiasActualizadas ++;
                        }
                        /*if(datosTr != undefined){
                          for(var j = 0; j < datosTr.length; j++){
                              if(datosTr[j].status.type == "D"){
                                  await apicon.updateDataApi(apicon.getApiBaseUrl() + 'guias/' + this.guias[i].id,{
                                      podnombre: datosTr[j].activityLocation.SignedForByName,
                                      podfecha: datosTr[j].Date,
                                      podhora: datosTr[j].Time
                                  })
                                  this.guias[i].podnombre = datosTr[j].ActivityLocation.SignedForByName;
                                  this.guias[i].podfecha = datosTr[j].Date.substr(0,4) + '-' + datosTr[j].Date.substr(4,2) + '-' + datosTr[j].Date.substr(6,2);
                                  this.guias[i].podhora = datosTr[j].Time.substr(0,2) + ':' + datosTr[j].Time.substr(2,2) + ':' + datosTr[j].Time.substr(4,2);
                                  this.guiasActualizadas ++;
                              }

                          }
                        }*/
                    } else if (result.proveedor == "DHL") {
                        //Verificar si la guia existe en el servidor
                        if(result.datos.detail){
                            this.guias[i].podnombre = result.datos.detail;
                        }else{
                            let shipment = result.datos.shipments[0];
                            //Verificar si tiene pod
                            let datosTr = shipment.events;
                            if(datosTr != undefined){
                              for(var j = 0; j < datosTr.length; j++){
                                  if(datosTr[j].typeCode == "OK"){
                                      await apicon.updateDataApi(apicon.getApiBaseUrl() + 'guias/' + this.guias[i].id,{
                                          podnombre: datosTr[j].signedBy,
                                          podfecha: datosTr[j].date,
                                          podhora: datosTr[j].time
                                      })
                                      this.guias[i].podnombre = datosTr[j].signedBy;
                                      this.guias[i].podfecha = datosTr[j].date;//datosTr[j].Date.substr(0,4) + '-' + datosTr[j].Date.substr(4,2) + '-' + datosTr[j].Date.substr(6,2);
                                      this.guias[i].podhora = datosTr[j].time;//datosTr[j].Time.substr(0,2) + ':' + datosTr[j].Time.substr(2,2) + ':' + datosTr[j].Time.substr(4,2);
                                      this.guiasActualizadas ++;
                                  }
                              }
                            }
                        }
                    }
                });
                this.currentGuia ++;
            }
            this.overlay = false;
            this.currentGuia = 1;
        },
        formatDate: function(date){
            return utils.formatDate(date)
        },
    },
    mounted: function(){
        apicon.setAuthHeaders();
    }
}
</script>
